/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/structural_template/canvas_template_upsert" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdStructuralTemplateCanvasTemplateUpsertCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdStructuralTemplateCanvasTemplateUpsertProps,
  EngagementAppGroupIdStructuralTemplateCanvasTemplateUpsertResult,
} from "./types";

export const postEngagementAppGroupIdStructuralTemplateCanvasTemplateUpsert = reactQueryMutationAdapter(
  engagementAppGroupIdStructuralTemplateCanvasTemplateUpsertCacheKeys,
  (
    props: PostEngagementAppGroupIdStructuralTemplateCanvasTemplateUpsertProps
  ): Promise<EngagementAppGroupIdStructuralTemplateCanvasTemplateUpsertResult> => {
    return fetch(
      `/engagement/${props.appGroupId}/structural_template/canvas_template_upsert`,
      "POST",
      props,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
